
export function getBrennwerteUmrechnungsfaktor(energietraeger_id: string): any {
    switch (energietraeger_id) {
        case 'biogas':
            return {
                wert: 0.9100,
                quelle: 'DESNZ (2025)'
            };
        case 'bio_brennholz':
            return {
                wert: 0.9048,
                quelle: 'DESNZ (2025)'
            };
        case 'bio_hackschnitzel':
            return {
                wert: 0.9244,
                quelle: 'DESNZ (2025)'
            };
        case 'bio_holzpellets':
            return {
                wert: 0.9243,
                quelle: 'DESNZ (2025)'
            };
        case 'erdgas':
            return {
                wert: 0.9063,
                quelle: 'DESNZ (2025)'
            };
        case 'fluessiggas':
            return {
                wert: 0.9083,
                quelle: 'BAFA (2024)'
            };
        case 'hel':
            return {
                wert: 0.9377,
                quelle: 'BAFA (2024)'
            };
        case 'braunkohle':
            return {
                wert: 0.9333,
                quelle: 'BAFA (2024)'
            };
        case 'steinkohle':
            return {
                wert: 0.9721,
                quelle: 'BAFA (2024)'
            };
    }
    return null;
}
